import { ChainEnv } from '@vertex-protocol/client';
import {
  appManagedWalletConnector,
  getPrimaryChain,
  KNOWN_CONNECTOR_IDS,
  WagmiConfigParams,
} from '@vertex-protocol/react-client';
import { getIsLocalTestWalletShortcutEnabled } from 'client/hooks/ui/localTestWalletShortcut';
import { DataEnv } from 'common/environment/baseClientEnv';
import { clientEnv } from 'common/environment/clientEnv';
import { arbitrum, mainnet } from 'viem/chains';
import type { Chain } from 'viem/chains';
import type { CreateConnectorFn } from 'wagmi';

// Stack'd Perps: Ink L2 primary, Ethereum + Arbitrum as bridge source chains.
const CHAIN_ENVS_BY_DATA_ENV: Record<DataEnv, ChainEnv[]> = {
  local: ['local'],
  inkMainnet: ['inkMainnet'],
  inkTestnet: ['inkTestnet'],
};

/**
 * Additional EVM chains supported for cross-chain deposits via USDT0 OFT bridge.
 * These are NOT Vertex/Nado chain envs — they're standard EVM chains the wallet
 * can switch to for bridging. The primary chain env is still Ink-only.
 */
const BRIDGE_SOURCE_CHAINS: Chain[] = [mainnet, arbitrum];

function getConnectors(): CreateConnectorFn[] {
  if (!getIsLocalTestWalletShortcutEnabled()) {
    return [];
  }

  return [
    appManagedWalletConnector({
      id: KNOWN_CONNECTOR_IDS.customWallet,
    }),
  ];
}

export function getWagmiConfigParams(): WagmiConfigParams {
  const supportedChainEnvs =
    CHAIN_ENVS_BY_DATA_ENV[clientEnv.base.dataEnv] ??
    CHAIN_ENVS_BY_DATA_ENV.inkMainnet;
  const primaryChains: Chain[] = supportedChainEnvs.map(getPrimaryChain);

  // Include bridge source chains so the wallet can switch to them for OFT deposits
  const supportedChains: Chain[] = [...primaryChains, ...BRIDGE_SOURCE_CHAINS];

  return {
    supportedChains,
    supportedChainEnvs,
    connectors: getConnectors(),
  };
}
